import { cache as cacheConfig } from '../../../../config';
const cacheModuleConfig = { verbose: false, defaultExpiration: 30, memcached: cacheConfig || {} };

export default (() => {
    if (process.browser) {
        const CacheService = require('cache-service-cache-module');
        return new CacheService({ defaultExpiration: 30 });
    }
    return require('./memcachedCacheService')(cacheModuleConfig);
})();



// WEBPACK FOOTER //
// ./app/lib/api/cache/index.js